// extracted by mini-css-extract-plugin
export default {"cell":"TableCell__cell___1YejK"};